<template>
  <div
    v-for="(element, index) in facet.elements"
    :key="index"
    role="radio"
    :aria-checked="element.selected"
    :class="{
      'fact-finder-fite-checkbox-fi': true,
      'fact-finder-fite-checkbox-fi--disabled': element.disabled,
      'fact-finder-fite-checkbox-fi--selected': element.selected,
    }"
    @click.capture.stop="onClick(element)"
  >
    <label
      class="fact-finder-fite-checkbox-fi__label"
      :class="{
        'fact-finder-fite-checkbox-fi__label-selected': element.selected,
        'fact-finder-fite-checkbox-fi__label-disabled': element.disabled,
      }"
    >
      {{ element.text }} {{ facet.unit }}
      <icon-fi
        :icon="element.selected ? 'radio-btn-on' : 'radio-btn-off'"
        :class="{
          'fact-finder-fite-checkbox-fi__checkbox': true,
          'fact-finder-fite-checkbox-fi__checkbox--disabled': element.disabled,
        }"
      />
    </label>
  </div>
</template>
<script setup lang="ts">
import { IconFi } from 'atoms/index';

import type {
  Facet,
  FacetChange,
  FacetElement,
} from '../fact-finder-facet-fi/fact-finder-facet-type';

const emit = defineEmits<{
  change: [FacetChange];
}>();

defineProps<{
  facet: Facet;
}>();

const onClick = (element: FacetElement) => {
  if (element.disabled) {
    return;
  }
  emit('change', { element: element, value: !element.selected });
};
</script>

<style lang="scss" scoped>
@import './fact-finder-fite-checkbox-fi';
</style>
